import { render, staticRenderFns } from "./exercise-detail.vue?vue&type=template&id=3ff1d3db&"
import script from "./exercise-detail.vue?vue&type=script&lang=js&"
export * from "./exercise-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports